import { render, staticRenderFns } from "./ProductCategory.vue?vue&type=template&id=a9717086&scoped=true&"
import script from "./ProductCategory.vue?vue&type=script&lang=js&"
export * from "./ProductCategory.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategory.vue?vue&type=style&index=0&id=a9717086&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9717086",
  null
  
)

export default component.exports